import { render, staticRenderFns } from "./BinanceIncome.vue?vue&type=template&id=af520142&scoped=true&"
import script from "./BinanceIncome.vue?vue&type=script&lang=js&"
export * from "./BinanceIncome.vue?vue&type=script&lang=js&"
import style0 from "./BinanceIncome.vue?vue&type=style&index=0&id=af520142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af520142",
  null
  
)

export default component.exports